<template>
  <div class="container" id="result">
    <!-- <h1>結果</h1> -->
    <h2>{{ Math.ceil(timer / 10) }}.{{ Math.ceil(timer % 10) }} 秒</h2>
    <h3>
      {{ this.rank }}
      <span class="rank-unit">レベル</span>
    </h3>
    <div class="message">{{ message }}</div>
    <a
      class="waves-effect waves-light btn btn-twitter light-blue lighten-2"
      :href="
        'http://twitter.com/share?url=https://tencount-f5bfb.web.app/&text=【点数表暗記ドリル】' +
          difficulty +
          '%20解答タイム%20' +
          Math.floor(timer / 10) +
          '.' +
          Math.ceil(timer % 10) +
          '秒%0a' +
          rank +
          'レベル！点数計算を練習中！%0a&hashtags=点数計算ドリル'
      "
      target="_blank"
      >Twitter</a
    >
    <p class="sub-text">
      勉強になると感じて頂けたら
      <br />共有してもらえると嬉しいです！ <br />改善要望もお待ちしてます。
    </p>
    <div class="flex mb-4">
      <a
        class="waves-effect waves-light btn btn-top grey lighten-1"
        @click="goTop"
        >ホーム</a
      >
      <a
        class="waves-effect waves-light btn btn-retry pink lighten-2"
        @click="retry"
        >再挑戦</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "result",
  data() {
    return {
      level: 1,
      length: 10,
      ko: 1,
      agari: 1,
      counter: 1,
      correct: 0,
      timer: 0,
      rank: "ビギナー",
      message: "繰り返し解いて覚えよう！",
      difficulty: "初級",
    };
  },
  methods: {
    retry() {
      this.counter = 1;
      this.correct = 0;
      this.page = 1;
      this.$router.push({
        name: "drill",
        query: {
          level: this.level,
          length: this.length,
          ko: this.ko,
          agari: this.agari,
        },
      });
    },
    goTop() {
      this.$router.push("/");
    },
  },
  created() {
    this.level = this.$route.query.level;
    this.length = this.$route.query.length;
    this.ko = this.$route.query.ko;
    this.agari = this.$route.query.agari;
    this.timer = this.$route.query.timer;
    // result text
    if (this.timer < 80) {
      this.rank = "鬼タップ";
      this.message = `早すぎィ!!`;
    } else if (this.timer < 100) {
      this.rank = "麻雀の神";
      this.message = `他のパターンも
解いてみましょう!!`;
    } else if (this.timer < 140) {
      this.rank = "雀荘オーナー";
      this.message = `他のパターンも
解いてみましょう!!`;
    } else if (this.timer < 200) {
      this.rank = "雀荘店員";
      this.message = `かなりいい感じ。
もう一息!!`;
    } else if (this.timer < 260) {
      this.rank = "常連客";
      this.message = `なかなかやりますね!!`;
    } else if (this.timer < 320) {
      this.rank = "雀荘デビュー";
      this.message = `継続は力なり!!`;
    } else if (this.timer < 400) {
      this.rank = "仲間うち";
      this.message = `九九のように
すらっと言えるようになろう!!`;
    } else {
      this.rank = "ビギナー";
      this.message = `繰り返し解いて
覚えよう!!`;
    }
    // twitter text
    if (this.level === 1) {
      this.difficulty = "初級";
    } else if (this.level === 2) {
      this.difficulty = "中級";
    } else {
      this.difficulty = "上級";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/style.scss";

h2 {
  margin: 30px 0 10px;
  color: #333;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
}
h3 {
  margin: 20px 0 0px;
  color: $theme-color;
}
.btn-twitter {
  margin-top: 40px;
}
.btn-top {
  color: #fff;
}
.rank-unit {
  font-size: 20px;
  color: #666;
}
.message {
  color: #333;
  font-size: 18px;
  line-height: 21px;
  margin-top: 0px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.sub-text {
  margin-top: 12px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.flex a {
  width: 46%;
}
</style>
